import apiClient from 'utilities/apiClient';

export const staff_assign = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.staffing}/${url}`, payload, true);
};

export const staff_project = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.staffing}/${url}`, payload, true);
};
